import React from 'react'

import MenuItem from '@/modules/layout/components/menu/item/menu-item'
import { getMarketplaceMenuItem, menuItemsCenter } from '@/modules/layout/components/menu/config'
import { isMobileScreen } from '@/modules/_helpers/detectMobile'
import { isMeinBuero } from '@/utils/build-env'

import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import { isObject } from 'lodash'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  content: {
    width: '100%',
  },
  [theme.devices.mobile]: {
    content: {
      marginTop: 15,
    },
  },
}))

const MenuBar = ({ handleMenuItemClick }) => {
  const userInfo = useSelector(state => state.user.info)
  const { details: { loading } } = useSelector(state => state.subscription)
  const appsMenuItems = useSelector(state => state.apps.menuItems)
  const isMboMobileScreen = isMeinBuero() && isMobileScreen()

  const classes = useStyles()

  const menuItems = [
    ...menuItemsCenter(appsMenuItems),
    ...((isMboMobileScreen && getMarketplaceMenuItem(userInfo, true)) || []),
  ]

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        {!loading && isObject(userInfo.roles) && Object.keys(userInfo.roles).length && menuItems.map((menuItemData) => {
          const { name } = menuItemData
          return (
            <MenuItem key={name} {...menuItemData} handleItemClick={handleMenuItemClick} />
          )
        })}
      </div>
    </div>
  )
}

export default MenuBar
